














import { Component, Vue } from "vue-property-decorator";
import UserService from "@/api/services/userService";

@Component
export default class Menu extends Vue {
  usersService = new UserService(this);

  logout() {
    this.$cookies.remove("token");
    this.$store.dispatch("setLoggedIn", false);
    this.$router.push("/login");
  }
}
